import FooterLayout from './FooterLayout'

export default FooterLayout
